const { VUE_APP_RSA_PUBLIC_LAMBDA_PROFILE } = process.env;

const NO_VALID_PHONES = [
  '123456789',
  '111111111',
  '222222222',
  '333333333',
  '444444444',
  '555555555',
  '666666666',
  '777777777',
  '888888888',
  '999999999',
  '000000000',
]

export const getSafe = (cb) => {
  try {
    return cb();
  } catch (error) {
    // console.error(error);
  }
  return null;
};

function pemToArrayBuffer(pem) {
  const pemHeader = '-----BEGIN PUBLIC KEY-----';
  const pemFooter = '-----END PUBLIC KEY-----';
  const pemContents = pem
    .replace(pemHeader, '')
    .replace(pemFooter, '')
    .replace(/\s+/g, '');

  const binaryString = atob(pemContents);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }

  return bytes.buffer;
}

async function importRSAPublicKey(pem) {
  const arrayBuffer = pemToArrayBuffer(pem)
  const cryptoSub = await crypto.subtle.importKey(
    'spki',
    arrayBuffer,
    {
      name: 'RSA-OAEP',
      hash: { name: 'SHA-256' }
    },
    true,
    ['encrypt']
  )
  return cryptoSub;
}

export async function encryptData(data) {
  const publicKey = await importRSAPublicKey(VUE_APP_RSA_PUBLIC_LAMBDA_PROFILE)
  const encoder = new TextEncoder()
  const encodedData = encoder.encode(data)
  try {
    const encryptedData = await crypto.subtle.encrypt(
      {
        name: 'RSA-OAEP'
      },
      publicKey,
      encodedData
    )
    return new Uint8Array(encryptedData)
  } catch (error) {
    console.log(error)
  }
  return null
}

export const secureEmail = (email) => {
  if (!email) return "";
  const [username, domain] = email.split("@");
  const secure = username
    .split("")
    .map((char, i, arr) => {
      if (i < 2 || i > arr.length - 2) return char;
      return "*";
    })
    .join("");
  return `${secure}@${domain}`;
};

export const securePhone = (phone) => {
  const str = phone.toString()
  const secure = str
    .split("")
    .map((char, i, arr) => {
      if (i < 1 || i > arr.length - 3) return char;
      return "*";
    })
    .join("");
  return `${secure}`;
};

export const getServerError = (error) => {
  const message = getSafe(() => error.response.data.error.message[0].message);
  let auxMessage = '';
  if (typeof message === 'object') {
    auxMessage = message[0].message;
  } else {
    auxMessage = message;
  }
  return auxMessage || 'Inténtalo de nuevo en unos minutos.';
};

export const validatePhone = (phone, phonecode) => {
  if (NO_VALID_PHONES.includes(phone)) {
    return 'El número de teléfono no es válido.';
  }
  if (phonecode === 51 && !phone.startsWith('9')) {
    return 'El número de teléfono debe empezar con 9.';
  }
  return '';
};

export const onlyText = (event, value, type) => {
  if(type && type === 'correo') return;
  // eslint-disable-next-line
  const regular = /^[a-zA-ZñÑáéíóúÁÉÍÓÚ ]+$/;
  const regex = new RegExp(regular);
  const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key) || (value[0] === undefined && /^\s/.test(key))) {
    event.preventDefault();
    return;
  }
  // eslint-disable-next-line consistent-return
  return true;
};

// eslint-disable-next-line consistent-return
export const onlyNumber = (event) => {
  event = event || window.event;
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  } else {
    return true;
  }
};

export const alphaNumeric = (event) => {
  const char = String.fromCharCode(event.which || event.keyCode);
  if (!/^[a-zA-Z0-9]+$/.test(char)) {
    event.preventDefault();
  }
};

export const verifyPhone = (event, value) => {
  const regular = /^\+\d{0,15}$/;
  const regex = new RegExp(regular);
  const { key } = event;
  const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
  if (controlKeys.includes(key)) {
    return true;
  }
  if (value.length === 0 && key !== '+') {
    event.preventDefault();
    return false;
  }
  if (event.target.selectionStart === 0 && key !== '+') {
    event.preventDefault();
    return false;
  }
  if (key === '+' && value.includes('+')) {
    event.preventDefault();
    return false;
  }
  if (!/^\d$/.test(key) && key !== '+') {
    event.preventDefault();
    return false;
  }
  const newValue = value + key;
  if (!regex.test(newValue)) {
    event.preventDefault();
    return false;
  }
  return true;
};
